<template>
  <div>
    <member-top :userInfo="user" :statistics="statistics"></member-top>
    <div class="w1200 wrap mt20 mb30">
      <Menu :menus="menus"></Menu>
      <div class="col_2 w920 member_right_con">
        <router-view></router-view>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>

import MemberTop from '@/components/byl/memTop/top.vue'
import Menu from '@/components/common/menu/menu.vue'
import { mapState, mapActions } from 'vuex'

export default {
  components: { MemberTop, Menu },
  props: ['menus'],
  data () {
    return {
      headerTxt: '管理企业',
      userInfo: {},
      statistics: {
        cnt0: 0,  // 已完成课程数量
        cnt1: 0,  // 完成考试问卷数
        cnt2: 0   // 获得证书数量
      }
    }
  },
  created () {
    this.getUserExamCnt()
    this.getUserCertCnt()
    this.getUserCourseCnt()
  },
  mounted () {
  },
  computed: {
    ...mapState('auth', ['user', 'token'])
  },
  methods: {
    ...mapActions('auth', {
      logout: 'logout'
    }),
    toLogout () {
      this.logout(this.user.id)
    },
    toReg () {
      this.$router.push('/byl/orgreg')
    },
    toRecord () {
      this.$router.push('/org')
    },
    getUserInfo (id) {
      this.$api.get(this.$global.bylBaseCenterPath, '/user/' + id, {}, r => {
        if (r.data) {
          this.$emit('data-prepared', r.data)
        }
      })
    },
    getUserExamCnt () {
      this.$api.post(this.$global.examApiPath, '/examExamScore/getCountByUser', {}, r => {
        if (r.data && r.data.cntFinish) {
          this.statistics.cnt1 = r.data.cntFinish
        }
      })
    },
    getUserCourseCnt () {
      this.$api.post(this.$global.courseApiPath, '/course/info/count', {}, r => {
        if (r.data && r.data.learned) {
          this.statistics.cnt0 = r.data.learned
        } else {
          this.statistics.cnt0 = 0
        }
      })
    },
    getUserCertCnt () {
      this.$api.post(this.$global.bylApiPath, '/cert/certNum', {}, r => {
        if (r.data) {
          this.statistics.cnt2 = r.data
        } else {
          this.statistics.cnt2 = 0
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/uc/index.vue